module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_m_normal.2ff168b4.png";